let socialLinks = [
  {
    github: "https://github.com/pperdana",
    frontendMentor: "https://www.frontendmentor.io/profile/pperdana",
    email: "panjiperdana088@gmail.com",
    youtube: "https://www.youtube.com",
  },
];

export default socialLinks;
